import { Loader } from '@googlemaps/js-api-loader';

export interface IAddress {
  streetNumber?: string;
  streetName?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  county?: string;
  borough?: string;
  state?: string;
  stateCode?: string;
  country?: string;
  countryCode?: string;
  postalCode?: string;
  latitude?: number;
  longitude?: number;
  formattedAddress: string;
}

// Singleton class to handle Google Maps API initialization
export class GoogleMapsService {
  private static instance: GoogleMapsService | null = null;
  private loader: Loader;
  private loadPromise: Promise<typeof google> | null = null;

  private constructor() {
    this.loader = new Loader({
      apiKey: process.env.REACT_APP_PLACES_API_KEY || '',
      version: 'weekly',
      libraries: ['places'],
    });
  }

  public static getInstance(): GoogleMapsService {
    if (!GoogleMapsService.instance) {
      GoogleMapsService.instance = new GoogleMapsService();
    }
    return GoogleMapsService.instance;
  }

  public async load(): Promise<typeof google> {
    if (!this.loadPromise) {
      this.loadPromise = this.loader.load();
    }
    return this.loadPromise;
  }
}
